import React, { useEffect } from 'react';
import "../../styles/Services.css";
import GetInTouch from '../../components/GetInTouch';
const webIcon1 = "/assets/icons/web_icon_1.png";
const webIcon2 = "/assets/icons/web_icon_2.png";
const webIcon3 = "/assets/icons/web_icon_3.png";
const webIcon4 = "/assets/icons/web_icon_4.png";

const WebDevelopment = () => {

  useEffect(() => {
    document.title = 'Web Development | Inypeople';
  }, []);

  return (
    <>
      <section className="web-dev-section">
        <div className="web-dev-container">
          <h1 className="web-dev-title">Web Development</h1>

          <p className="web-dev-description">
            At Inypeople, we are sector specialists in Website Development, crafting visually compelling and high-performing websites tailored to your industry's unique needs. Our deep understanding of diverse business sectors allows us to create digital experiences that stand out in your niche and convert visitors into loyal customers.
          </p>

          <p className="web-dev-subtitle">
            We combine creative design, robust technology, and user-centric functionality to deliver websites that are scalable, secure, and results-driven.
          </p>
        </div>

        <div className="circle circle-left"></div>
        <div className="circle circle-right"></div>
        <div className="circle circle-right-top"></div>
        <div className="circle circle-left-bottom"></div>
      </section>

      <section className="services-section">
        <div className="services-container">
          <h2 className="services-main-title">
            Build, launch, and grow with our web development services.
          </h2>

          <div className="services-grid">

            {/* CARD 1 */}
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img src={webIcon1} alt="Web Development Icon" className="service-icon-img" />
                  </div>
                  <h3 className="service-title">Custom & Full-Stack Development</h3>
                </div>

                <p className="service-description">
                  We build secure, scalable custom websites and full-stack development tailored to your business, delivering seamless experiences from front end to back end.
                </p>
              </div>
            </div>

            {/* CARD 2 */}
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img src={webIcon2} alt="Web Development Icon" className="service-icon-img" />
                  </div>
                  <h3 className="service-title">E-Commerce Development</h3>
                </div>

                <p className="service-description">
                  Powerful, secure, and scalable e-commerce solutions that deliver seamless shopping experiences and drive online sales.
                </p>
              </div>
            </div>

            {/* CARD 3 */}
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img src={webIcon3} alt="Web Development Icon" className="service-icon-img" />
                  </div>
                  <h3 className="service-title">Content Management Systems (CMS)</h3>
                </div>

                <p className="service-description">
                  Flexible and easy-to-manage CMS solutions that give you complete control over your website content.
                </p>
              </div>
            </div>

            {/* CARD 4 */}
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img src={webIcon4} alt="Web Development Icon" className="service-icon-img" />
                  </div>
                  <h3 className="service-title">Integration, Migration & Maintenance</h3>
                </div>

                <p className="service-description">
                  End-to-end support including system integrations, smooth platform migrations, performance optimization, and ongoing maintenance to keep your website running flawlessly.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Get In Touch Section */}
      <GetInTouch />
    </>
  );
};

export default WebDevelopment;
